import React from 'react';

import {
  Button,
  Col,
  FormattedTextField,
  MortgageHeader,
  Row,
} from '@elevationscu/ui-component-lib';

import { getPrincipleInterest, getRemainingInterest } from '@elevationscu/common-mortgage-calculator';

import '../styles/common.scss';
import './New.scss';

function Test() {
  const applyLink = 'https://applymortgage.elevationscu.com/#/milestones';
  const isMobile = false;

  const [interestRate, setInterestRate] = React.useState();
  const [loanTerm, setLoanTerm] = React.useState();
  const [loanAmount, setLoanAmount] = React.useState();
  const [principleInt, setPrincipleInt] = React.useState(null);
  const [remLoanAmount, setRemLoanAmt] = React.useState();
  const [remainingMonths, setRemMon] = React.useState();
  const [remIR, setRemIr] = React.useState();
  const [monthlyPayment, setMonPay] = React.useState();
  const [remInt, setRemInt] = React.useState();

  const handleCalculate = () => {
    const tmpPrincipalInt = getPrincipleInterest(interestRate, loanTerm, loanAmount);
    setPrincipleInt(tmpPrincipalInt);
  };

  const handleRemInterest = () => {
    const tmpRemInt = getRemainingInterest(remLoanAmount, remIR, monthlyPayment);
    setRemInt(tmpRemInt);
  };

  const handleInterestChange = (event) => {
    setInterestRate(event.target.value);
  };

  const handleTermChange = (event) => {
    setLoanTerm(event.target.value);
  };

  const handleAmountChange = (event) => {
    setLoanAmount(event.target.value);
  };

  return (
    <main>
      <div className="headerDiv hide-on-print">
        <MortgageHeader />
      </div>
      <span className="hide-on-print">
        <span className={isMobile ? 'mobileHeaderApplyButton' : 'headerApplyButton'}>
          {/* TODO: Apply link used to include lo referrer, who is the new referrer (see prospect ui)? */}
          <Button id="apply_btn_top" url={`${applyLink}`}>Apply</Button>
        </span>
      </span>
      <Col>
        <Row className="refiRow">
          {principleInt && (
            <div>
              <h1>
                Principal and interest:
                {principleInt}
              </h1>
            </div>
          )}
        </Row>
        <Row className="refiRow">
          <FormattedTextField label="Interest rate" value={interestRate} onBlur={(e) => { handleInterestChange(e); }} />
        </Row>
        <Row className="refiRow">
          <FormattedTextField label="Loan term (months)" value={loanTerm} onBlur={(e) => { handleTermChange(e); }} />
        </Row>
        <Row className="refiRow">
          <FormattedTextField label="Loan amount" value={loanAmount} onBlur={(e) => { handleAmountChange(e); }} />
        </Row>
        <Row className="refiRow">
          <Button id="viewClosingCostButton" variant="secondary" onClick={() => handleCalculate()}>
            Calculate
          </Button>
        </Row>
      </Col>
      <Col>
        <Row className="refiRow">
          {remInt && (
            <div>
              <h1>
                Remianing Interest:
                {remInt}
              </h1>
            </div>
          )}
        </Row>
        <Row className="refiRow">
          <FormattedTextField label="Interest rate" value={remIR} onBlur={(e) => { setRemIr(e.target.value); }} />
        </Row>
        <Row className="refiRow">
          <FormattedTextField label="remaining Loan term (months)" value={remainingMonths} onBlur={(e) => { setRemMon(e.target.value); }} />
        </Row>
        <Row className="refiRow">
          <FormattedTextField label="remiaing Loan amount" value={remLoanAmount} onBlur={(e) => { setRemLoanAmt(e.target.value); }} />
        </Row>
        <Row className="refiRow">
          <FormattedTextField label="monthly payment" value={monthlyPayment} onBlur={(e) => { setMonPay(e.target.value); }} />
        </Row>
        <Row className="refiRow">
          <Button id="viewClosingCostButton" variant="secondary" onClick={() => handleRemInterest()}>
            Calculate
          </Button>
        </Row>
      </Col>
    </main>
  );
}

export default Test;
